import {
  masterTableDateTimeFormat,
  masterTableStartDateTimeFormat,
} from "../../Shared/Utils/DateConverter";
const COLUMN_LABELS = {
  districtName: "District Name",
  approvedBy: "Approved By",
  approvedDateTime: "Approved Date & Time",
  talukaName: "Taluka Name",
  lgbName: "LGB Name",
  corporationName: 'Corporation Name',
  subcenterName: "Subcenter Name",
  programName: "Program Name",
};
export const areaTypeColumns = [
  {
    field: "areaCode",
    header: "Area Code",
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "areaTypeName",
    header: "Area Type",
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "areaCategoryName",
    header: "Area Category",
    filter: true,
    showFilterMenu: false,
  },
  { field: "status", header: "Status", filter: true, showFilterMenu: false },
];
export const districtColumns = [
  { field: "select", header: "Select" },
  { field: "remarks" },
  {
    field: "districtCode",
    header: "District Code",
    showFilterMenu: false,
  },
  {
    field: "districtName",
    header: COLUMN_LABELS.districtName,
    filter: true,
    showFilterMenu: false,
  },
  { field: "status", header: "Status",showFilterMenu: false },
  {
    field: "recModifiedBy",
    header: COLUMN_LABELS.approvedBy,
    showFilterMenu: false,
  },
  {
    field: masterTableDateTimeFormat,
    header: COLUMN_LABELS.approvedDateTime,
    filterField: "recModifiedDate",
  },
];

export const talukaColumns = [
  { field: "select", header: "Select" },
  { field: "remarks" },
  {
    field: "talukaCode",
    header: "Taluka Code",
    showFilterMenu: false,
  },
  {
    field: "talukaName",
    header: COLUMN_LABELS.talukaName,
    filter: true,
    showFilterMenu: false,
  },
  { field: "status", header: "Status",showFilterMenu: false },
  {
    field: "districtName",
    header: COLUMN_LABELS.districtName,
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "recModifiedBy",
    header: COLUMN_LABELS.approvedBy,
    showFilterMenu: false,
  },
  {
    field: masterTableDateTimeFormat,
    header: COLUMN_LABELS.approvedDateTime,
    filterField: "recModifiedDate",
  },
];
export const governingbodyColumns = [
  { field: "select", header: "Select", frozen: true },
  { field: "remarks", frozen: true },
  {
    field: "lgbIdCode",
    header: "LGB Code",
    showFilterMenu: false,
  },
  {
    field: "lgbName",
    header: COLUMN_LABELS.lgbName,
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "areaType",
    header: "Area Type",
    showFilterMenu: false,
  },
  { field: "status", header: "Status",showFilterMenu: false },
  {
    field: "recModifiedBy",
    header: COLUMN_LABELS.approvedBy,
    showFilterMenu: false,
  },
  {
    field: masterTableDateTimeFormat,
    header: COLUMN_LABELS.approvedDateTime,
    filterField: "recmodifieddate",
  },
];
export const corporationColumns = [
  { field: "select", header: "Select", frozen: true },
  { field: "remarks" },
  {
    field: "corporation_council_code",
    header: "Corporation Code",
    showFilterMenu: false,
  },
  {
    field: "corporation_coucil_name",
    header: COLUMN_LABELS.corporationName,
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "lgbName",
    header: COLUMN_LABELS.lgbName,
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "districtName",
    header: COLUMN_LABELS.districtName,
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "status",
    header: "Status",
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: "talukaName",
    header: COLUMN_LABELS.talukaName,
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "areaType",
    header: "Area Type",
    showFilterMenu: false,
  },
  { field: "status", header: "Status",showFilterMenu: false },
  {
    field: "recModifiedBy",
    header: COLUMN_LABELS.approvedBy,
    showFilterMenu: false,
  },
  {
    field: masterTableDateTimeFormat,
    header: COLUMN_LABELS.approvedDateTime,
    filterField: "recmodifieddate",
  },
];
export const phcColumns = [
  { field: "select", header: "Select", frozen: true },
  { field: "remarks", frozen: true },
  {
    field: "phcCode",
    header: "PHC Code",
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: "phcName",
    header: "PHC Name",
    filter: true,
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: "status",
    header: "Status",
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: "talukaName",
    header: COLUMN_LABELS.talukaName,
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "areaType",
    header: "Area Type",
    showFilterMenu: false,
  },
  {
    field: "areaCategory",
    header: "Area Category",
    showFilterMenu: false,
  },
  {
    field: "districtName",
    header: COLUMN_LABELS.districtName,
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "recModifiedBy",
    header: COLUMN_LABELS.approvedBy,
    showFilterMenu: false,
  },
  {
    field: masterTableDateTimeFormat,
    header: COLUMN_LABELS.approvedDateTime,
    filterField: "recModifiedDate",
  },
];
export const uphcColumns = [
  { field: "select", header: "Select", frozen: true },
  { field: "remarks", frozen: true },
  {
    field: "phcCode",
    header: "PHC Code",
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: "phcName",
    header: "PHC Name",
    filter: true,
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: "status",
    header: "Status",
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: "talukaName",
    header: COLUMN_LABELS.talukaName,
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "lgbName",
    header: COLUMN_LABELS.lgbName,
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "corporationName",
    header: COLUMN_LABELS.corporationName,
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "areaType",
    header: "Area Type",
    showFilterMenu: false,
  },
  {
    field: "districtName",
    header: COLUMN_LABELS.districtName,
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "recModifiedBy",
    header: COLUMN_LABELS.approvedBy,
    showFilterMenu: false,
  },
  {
    field: masterTableDateTimeFormat,
    header: COLUMN_LABELS.approvedDateTime,
    filterField: "recModifiedDate",
  },
];
export const subCenterColumns = [
  { field: "select", header: "Select", frozen: true },
  { field: "remarks", frozen: true },
  {
    field: "subcenterCode",
    header: "Subcenter Code",
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: "subcenterName",
    header: COLUMN_LABELS.subcenterName,
    filter: true,
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: "status",
    header: "Status",
    showFilterMenu: false,
    frozen: true,
  },
  { field: "phcName", header: "PHC Name", filter: true, showFilterMenu: false },
  {
    field: "talukaName",
    header: COLUMN_LABELS.talukaName,
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "districtName",
    header: COLUMN_LABELS.districtName,
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "recModifiedBy",
    header: COLUMN_LABELS.approvedBy,
    showFilterMenu: false,
  },
  {
    field: masterTableDateTimeFormat,
    header: COLUMN_LABELS.approvedDateTime,
    filterField: "recModifiedDate",
  },
];

export const villageColumns = [
  { field: "select", header: "Select", frozen: true },
  { field: "remarks", frozen: true },
  {
    field: "villageCode",
    header: "Village Code",
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: "villageName",
    header: "Village Name",
    filter: true,
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: "status",
    header: "Status",
    showFilterMenu: false,
    frozen: true,
  },

  {
    field: "subcenterName",
    header: COLUMN_LABELS.subcenterName,
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "phcName",
    header: "PHC Name",
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "talukaName",
    header: COLUMN_LABELS.talukaName,
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "districtName",
    header: COLUMN_LABELS.districtName,
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "recModifiedBy",
    header: COLUMN_LABELS.approvedBy,
    showFilterMenu: false,
  },
  {
    field: masterTableDateTimeFormat,
    header: COLUMN_LABELS.approvedDateTime,
    filterField: "recModifiedDate",
  },
];

export const subareaColumns = [
  { field: "select", header: "Select", frozen: true },
  { field: "remarks", frozen: true },
  {
    field: "villageCode",
    header: "Sub Area Code",
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: "villageName",
    header: "Sub Area Name",
    filter: true,
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: "status",
    header: "Status",
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: "phcName",
    header: "UPHC Name",
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "lgbName",
    header: "LGB Name",
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "talukaName",
    header: COLUMN_LABELS.talukaName,
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "districtName",
    header: COLUMN_LABELS.districtName,
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "recModifiedBy",
    header: COLUMN_LABELS.approvedBy,
    showFilterMenu: false,
  },
  {
    field: masterTableDateTimeFormat,
    header: COLUMN_LABELS.approvedDateTime,
    filterField: "recModifiedDate",
  },
];

export const bankColumns = [
  {
    field: "bankCode",
    header: "Bank Code",
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "bankName",
    header: "Bank Name",
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "bankBranchName",
    header: "Bank Branch Name",
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "bankBranchDistrictName",
    header: "Bank Branch District",
    filter: true,
    showFilterMenu: false,
  },
  { field: "status", header: "Status", filter: true, showFilterMenu: false },
  {
    field: "recModifiedBy",
    header: COLUMN_LABELS.approvedBy,
    filter: true,
    showFilterMenu: false,
  },
  {
    field: masterTableDateTimeFormat,
    header: COLUMN_LABELS.approvedDateTime,
    filterField: "recModifiedDate",
  },
];

export const bankBranchColumns = [
  {
    field: "bankCode",
    header: "Bank Code",
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "bankName",
    header: "Bank Name",
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "ifsc",
    header: "IFSC Code",
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "branchName",
    header: "Bank Branch Name",
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "stateName",
    header: "Branch State",
    filter: true,
    showFilterMenu: false,
  },

  {
    field: "districtName",
    header: "Branch District",
    filter: true,
    showFilterMenu: false,
  },
  { field: "address", header: "Address", filter: true, showFilterMenu: false },
];

export const roleColumns = [
  { field: "select", header: "Select" },
  { field: "remarks" },
  {
    field: "roleCode",
    header: "Role Code",
    showFilterMenu: false,
  },
  { field: "roleName", header: "Role", filter: true, showFilterMenu: false },
  { field: "status", header: "Status", filter: false, showFilterMenu: false },
  {
    field: "acessLevel",
    header: "Access Level",
    showFilterMenu: false,
  },
  {
    field: "recModifiedBy",
    header: COLUMN_LABELS.approvedBy,
    showFilterMenu: false,
  },
  {
    field: masterTableDateTimeFormat,
    header: COLUMN_LABELS.approvedDateTime,
    filterField: "recModifiedDate",
  },
];

export const userColumns = [
  { field: "select", header: "Select", frozen: true },
  { field: "remarks", frozen: true },
  {
    field: "userCode",
    header: "User Code",
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: "firstName",
    header: "First Name",
    filter: true,
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: "lastName",
    header: "Last Name",
    filter: true,
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: "roleName",
    header: "Role",
    filter: true,
    showFilterMenu: false,
    frozen: true,
  },
  { field: "status", header: "Status",showFilterMenu: false },
  {
    field: "designation",
    header: "Designation",
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "email",
    header: "Email Address",
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "mobileNo",
    header: "Contact No.",
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "districtName",
    header: COLUMN_LABELS.districtName,
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "talukaName",
    header: COLUMN_LABELS.talukaName,
    filter: true,
    showFilterMenu: false,
  },
  { field: "phcName", header: "PHC Name", filter: true, showFilterMenu: false },
  {
    field: "recModifiedBy",
    header: COLUMN_LABELS.approvedBy,
    showFilterMenu: false,
  },
  {
    field: masterTableDateTimeFormat,
    header: COLUMN_LABELS.approvedDateTime,
    filterField: "recModifiedDate",
  },
];

export const trainingColumns = [
  { field: "select", header: "Select" },
  { field: "remarks" },
  {
    field: "trainingName",
    header: "Training Name",
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "days",
    header: "Days",
  },
  {
    field: "status",
    header: "Status",
    showFilterMenu: false,
  },
  {
    field: "recModifiedBy",
    header: COLUMN_LABELS.approvedBy,
    showFilterMenu: false,
  },
  {
    field: masterTableDateTimeFormat,
    header: COLUMN_LABELS.approvedDateTime,
    filterField: "recModifiedDate",
  },
];
export const facultyColumns = [
  { field: "select", header: "Select" },
  { field: "remarks" },
  {
    field: "facultyCode",
    header: "Faculty Code",
    showFilterMenu: false,
  },
  {
    field: "facultyName",
    header: "Faculty Name",
    filter: true,
    showFilterMenu: false,
  },
  { field: "status", header: "Status",showFilterMenu: false },
  {
    field: "districtName",
    header: "District",
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "recModifiedBy",
    header: COLUMN_LABELS.approvedBy,
    showFilterMenu: false,
  },
  {
    field: masterTableDateTimeFormat,
    header: COLUMN_LABELS.approvedDateTime,
    filterField: "recModifiedDate",
  },
];
export const trainingCalendarColumns = [
  { field: "select", header: "Select", frozen: true },
  { field: "remarks", frozen: true },
  {
    field: "facultyName",
    header: "Faculty Name",
    filter: true,
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: "trainingName",
    header: "Training Name",
    filter: true,
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: masterTableStartDateTimeFormat,
    header: "Start Date",
    filterField: "startDate",
    frozen: true,
  },
  { field: "status", header: "Status",showFilterMenu: false },
  {
    field: "days",
    header: "No. of Days",
    showFilterMenu: false,
  },
  {
    field: "villageName",
    header: "Village Name",
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "subcenterName",
    header: COLUMN_LABELS.subcenterName,
    showFilterMenu: false,
    filter: true,
  },
  {
    field: "phcName",
    header: "PHC Name",
    showFilterMenu: false,
    filter: true,
  },
  {
    field: "talukaName",
    header: COLUMN_LABELS.talukaName,
    showFilterMenu: false,
    filter: true,
  },
  {
    field: "districtName",
    header: COLUMN_LABELS.districtName,
    showFilterMenu: false,
    filter: true,
  },
  {
    field: "recModifiedBy",
    header: COLUMN_LABELS.approvedBy,
    showFilterMenu: false,
  },
  {
    field: masterTableDateTimeFormat,
    header: COLUMN_LABELS.approvedDateTime,
    filterField: "recModifiedDate",
  },
];

export const programColumns = [
  { field: "select", header: "Select" },
  { field: "remarks" },
  {
    field: "programCode",
    header: "Program Code",
    showFilterMenu: false,
  },
  {
    field: "programName",
    header: COLUMN_LABELS.programName,
    filter: true,
    showFilterMenu: false,
  },
  { field: "status", header: "Status",showFilterMenu: false },
  {
    field: "areaTypeName",
    header: "Area Type",
    showFilterMenu: false,
  },
  {
    field: "recModifiedBy",
    header: COLUMN_LABELS.approvedBy,
    showFilterMenu: false,
  },
  {
    field: masterTableDateTimeFormat,
    header: COLUMN_LABELS.approvedDateTime,
    filterField: "recModifiedDate",
  },
];
export const schemeColumns = [
  { field: "select", header: "Select", frozen: true },
  { field: "remarks" },
  {
    field: "schemeCode",
    header: "Scheme Code",
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: "schemeName",
    header: "Scheme Name",
    filter: true,
    showFilterMenu: false,
    frozen: true,
  },
  { field: "status", header: "Status",showFilterMenu: false },
  {
    field: "programName",
    header: COLUMN_LABELS.programName,
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "areaType",
    header: "Area Type",
    showFilterMenu: false,
  },
  {
    field: "recModifiedBy",
    header: COLUMN_LABELS.approvedBy,
    showFilterMenu: false,
  },
  {
    field: masterTableDateTimeFormat,
    header: COLUMN_LABELS.approvedDateTime,
    filterField: "recModifiedDate",
  },
];
export const activityColumns = [
  { field: "select", header: "Select", frozen: true },
  { field: "remarks" },
  {
    field: "activityCode",
    header: "Activity Code",
    showFilterMenu: false,
    frozen: true,
  },

  {
    field: "activityName",
    header: "Activity Name",
    filter: true,
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: "incentiveFor",
    header: "Incentive For",
    showFilterMenu: false,
  },
  {
    field: "status",
    header: "Status",
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: "paymentRate",
    header: "Payment Rate",
    showFilterMenu: false,
  },
  {
    field: "schemeName",
    header: "Scheme Name",
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "programName",
    header: COLUMN_LABELS.programName,
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "areaType",
    header: "Area Type",
    showFilterMenu: false,
  },
  {
    field: "recModifiedBy",
    header: COLUMN_LABELS.approvedBy,
    showFilterMenu: false,
  },
  {
    field: masterTableDateTimeFormat,
    header: COLUMN_LABELS.approvedDateTime,
    filterField: "recModifiedDate",
  },
];
